import { closeLoading } from '@/utils/feedback/loading';
import router from '@/routers';
import pinia from '@/stores';
import App from './App.vue';
import '@/utils';

const app = createApp(App);
app.use(router);
app.use(pinia);
app.mount('#app');
app.config.errorHandler = (err, instance, info) => {
  console.error('app.errorHandler', err);
  console.error('app.instanceHandler', instance);
  console.info('app.infoHandler', info);
  closeLoading();
};
